$(".faq-item__top").click(function() {
    $(this).toggleClass("active").next().slideToggle(300);
})
 